import styled from "styled-components";

export const Page = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .container {
    min-width: 572px;
    min-height: 90%;
    height: 90%;
    background-color: ${({ theme }) => theme.colors.secondary10};
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 38px;
    .description {
      img {
        width: 30%;
      }
      display: flex;
      align-items: center;
      flex-direction: column;
      color: ${({ theme }) => theme.colors.secondary70};
      margin-bottom: 15px;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.secondary100};
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .text {
      font-size: 18px;
      font-weight: 500;
      align-self: flex-start;
      margin-bottom: 30px;
    }
    p {
      font-size: 15px;
      font-weight: 500;
      align-self: flex-start;
    }
    .error-message {
      color: red;
    }
    .label-input {
      border-radius: 2px;
      background-color: #ecf0f1;
      display: flex;
      align-items: center;
      margin: 8px;
      svg {
        color: #7f8c8d;
        padding: 0 5px;
      }
    }
    .form-group {
      border-radius: 8px;
      background-color: ${({ theme }) => theme.colors.secondary10};
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      margin: 14px 0px;
      width: 100%;
      height: 50px;
      border-radius: 8px;
      padding: 14px;
      svg {
        color: ${({ theme }) => theme.colors.primary};
      }
      input {
        outline: none;
        border: none;
        width: 100%;
        margin-left: 13px;
        font-size: 16px;
        color: ${({ theme }) => theme.colors.secondary70};
      }
      .vertical-line {
        width: 3px;
        height: 32px;
        background-color: ${({ theme }) => theme.colors.secondary70};
        margin-left: 13px;
        border-radius: 8px;
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      width: 100%;
      min-height: 50px;
      margin-top: 15px;
      border: none;
      border-radius: 8px;
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.secondary10};
      outline: none;
      cursor: pointer;
    }
    .loading {
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 191, 165, 0.5);
      .ant-spin-dot-item {
        background-color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;
